<template>
	<div class="news-wrap">
		<el-breadcrumb separator="/" class="path">
			<el-breadcrumb-item :to="{ path: '/' }" class="path-home"><i class="n el-icon-s-home"></i>首页</el-breadcrumb-item>
			<el-breadcrumb-item class="path-news">展会</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="news" v-loading="loading">
			<div class="content">
				<div class="left-column">
					<div class="list" >
						<div class="item" v-for="(item,i) in list" :key="i">
							<router-link :to="`/exhibit-detail-${item.id}`" target="_blank">
								<h2>{{item.title}}</h2>
								<el-image fit="cover" class="image" :src="$img(item.thumb)" @error="item.thumb = defaultGoodsImage" />
								<div class="con">
									<desc-text class="text" :text="item.content" :textStyle="{WebkitLineClamp:4}"></desc-text>
									<!-- <div class="desc">{{item.datetime.date}}</div> -->
									<div class="tags">
										<span>{{item.datetime.date}}</span>
									</div>
								</div>
							</router-link>
						</div>
					</div>
					<el-pagination
					  background
					  layout="prev, pager, next"
					  :total="total"
					  :page-size="pageSize"
					  :current-page="currentPage"
					  @current-change="getList"
					  >
					</el-pagination>
				</div>
				<div class="right-column">
					<news-sidebar></news-sidebar>
				</div>
			</div>
			<div class="ad-1"  v-if="ad1">
				<el-image :src="$img(ad1.adv_image)" fit="cover" @click="$router.pushToTab(ad1.adv_url.url)" />
			</div>
		</div>
	</div>
</template>

<script>
	import {
		newsList,
		newsCat
	} from "@/api/cms/news";
	import {
		exhibitList,
		// newsCat
	} from "@/api/cms/exhibit";
	
	import { adList } from "@/api/website"
	import { mapGetters } from "vuex"
	import SubTitle from "@/components/SubTitle"
	import DescText from "@/components/DescText"
	import newsSidebar from "../news/components/sidebar"
	
	export default {
		name: "exhibit_list",
		components: {
			SubTitle,
			DescText,
			newsSidebar
		},
		data: () => {
			return {
				// classList:[],
				list: [],
				loading: true,
				tabs:[],
				ad1:null,
				cat_id:null,
				total:0,
				pageSize:10,
				currentPage:1
			};
		},
		created() {
			this.cat_id = this.$route.path.replace('/exhibit-list-', '');
			this.getInfo();
		},
		computed: {
		    ...mapGetters(["defaultGoodsImage"])
		},
		methods: {
			getInfo() {
				// this.loading = false;
				this.getList()
				// this.getFlagList()
				this.getCat()
				this.getAd1();
			},
			getCat(){
				newsCat({
					list:true,
					// exclude:15,
					ids:[
						this.cat_id
					]
				}).then(res=>{
					if (res.code == 0 && res.data) {
						this.tabs = res.data;
					}
				})
			},
			getList(val){
				// console.log(333)
				this.currentPage  = val || this.currentPage
				exhibitList({
					cat_id:this.cat_id,
					page_size:this.pageSize,
					page:this.currentPage,
				}).then(res=>{
					if (res.code == 0 && res.data) {
						this.list = res.data.list;
						this.total = res.data.total
					}
					this.loading = false;
				}).catch(err => {
					this.loading = false;
					this.$message.error(err.message);
				});
			},
			getAd1(){
				adList({ keyword: "PC_EXHIBIT_INDEX" })
				.then(res => {
					this.ad1 = res.data.adv_list[0]
				})
				.catch(err => {
				})
			}
		}
	};
</script>
<style lang="scss" scoped>
.news-wrap {
	background: #ffffff;
	.path {
		padding: 15px 0;
	}
}

.news {
	// display: flex;
	padding-bottom: 20px;
}
	
.news .content{
	display: flex;
	flex-flow: wrap;
	width: 1210px;
	margin-bottom: 20px;
	.left-column{
		width: 900px;
		// flex: 1;
		display: block;
		.sub-list{
			.list{
				display: flex;
				.item:first-child{
					margin-left: 0;
				}
				.item{
					width: 33.333%;
					margin-left: 30px;
					// padding-bottom: 10px;
					border: 1px solid #efefef;
					margin-bottom: 20px;
					overflow:hidden;
					.image{
						width: 100%;
						height: 200px;
					}
					p{
						padding: 5px 10px;
						overflow: hidden;
						text-overflow:ellipsis;
						white-space: nowrap;
					}
					// padding: 15px;
				}
			}
		}
		.list{
			.item{
				display: block;
				overflow: hidden;
				h2{
					padding: 5px;
					width: 100%;
					display: block;
					overflow: hidden;
					text-overflow:ellipsis;
					white-space: nowrap;
					line-height: 60px;
				}
				.image{
					width: 22%;
					float: left;
					height: 140px;
				}
				.con{
					width: 78%;
					float: left;
					padding: 0  0 0 15px;
					overflow: hidden;
					box-sizing: border-box;
					.text{
						height: 115px;
					}
					.tags{
						span{
							float: right;
						}
					}
				}
			}
		}
		.el-pagination{
			margin-top: 15px;
		}
	}
	.right-column{
		// width: 260px;
		flex: 1;
		padding-left: 20px;
		overflow: hidden;
	}
}
.news .ad{
	display: block;
}
</style>
